import { Modal, ModalHeader, ModalBody, ModalFooter, MODAL_SIZES } from 'ui/modal';
import { DestructiveButton } from 'ui/button';

type DeleteSystemWebhookModalProps = {
  /** Is delete modal open */
  isDeleteModalOpen: boolean;
  /** Function to be run when delete modal is closed */
  onDeleteModalClose: () => void;
  /** Function that deletes webhook given list id */
  deleteWebhook: (webhookId: number) => void;
  /** Webhook id number */
  deleteWebhookId: number;
};

export const DeleteSystemWebhookModal = ({
  isDeleteModalOpen,
  onDeleteModalClose,
  deleteWebhook,
  deleteWebhookId,
}: DeleteSystemWebhookModalProps) => {
  const handleConfirmDelete = () => {
    deleteWebhook(deleteWebhookId);
    onDeleteModalClose();
  };

  return isDeleteModalOpen ? (
    <Modal
      id="deleteSystemWebhookModal"
      data-test="deleteSystemWebhookModal"
      onClose={onDeleteModalClose}
      isModalOpen={isDeleteModalOpen}
      size={MODAL_SIZES.SMALL}
    >
      <ModalHeader>Delete webhook</ModalHeader>
      <ModalBody>Delete webhook with id {deleteWebhookId}?</ModalBody>
      <ModalFooter hasCancel onClose={onDeleteModalClose}>
        <DestructiveButton onClick={handleConfirmDelete} data-test="confirmDeleteWebhook">
          Delete
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  ) : null;
};
